module.exports = __webpack_public_path__ + "../public/img/seloHigiene.d6ad721b.png";